<div
  class="processing-overlay"
  [class.processing-overlay--visible]="visible()"
  role="status"
  [attr.aria-busy]="visible()">
  <div class="processing-overlay__content">
    <span class="processing-overlay__text" aria-live="polite">{{ statusText() }}</span>
    <app-progress-bar
      [value]="progressValue()"
      [class.indeterminate]="isIndeterminate()" />
  </div>
</div>
